 export const checkPermiso = (needle,permissions = []) =>{
 
    if(permissions.length > 0){
        let resultado = permissions.indexOf(needle) >= 0 ? true:false;
        //console.log("RESULTADO",resultado);
        return resultado;
    }

    return null;
 } 